export const DEAL_FREEZE_ONBOARDING_EXPERIMENT =
  'cd92d4b1-deal-freeze-onboarding-web-v2'

export const DEAL_FREEZE_ONBOARDING_COMPONENT = 'DealFreezeOnboarding'

export const DEAL_FREEZE_ONBOARDING_CONTINUE = 'DealFreezeOnboardingContinue'

export const DEAL_FREEZE_ONBOARDING_CLOSE = 'DealFreezeOnboardingClose'
